import { render } from "./JobCard.vue?vue&type=template&id=16c971aa&scoped=true"
import script from "./JobCard.vue?vue&type=script&lang=js"
export * from "./JobCard.vue?vue&type=script&lang=js"

import "./JobCard.vue?vue&type=style&index=0&id=16c971aa&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16c971aa"]])

export default __exports__